import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HappyHoursComponent } from '@app/components/happy-hours/happy-hours.component';

@Component({
  selector: 'app-page-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  imports: [
    HappyHoursComponent,
  ],
  host: {
    'class': 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {}
